import { ErrorFallbackProps, ErrorFallbackBase } from './ErrorFallbackBase';

// Niveau 3 (PrivateNavBarErrorBoundary / PrivateMainErrorBoundary) : erreur dans le contenu, navigation intacte
export const ContentErrorFallback = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase
    {...props}
    title="Erreur de chargement"
    message="Le contenu n'a pas pu être affiché."
    showHome={false}
    showDebugDetails
    compact
  />
);
